.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-height: var(--control-height);
  padding: 0 var(--space-4);
  border-radius: var(--radius-control);
  border: 1px solid transparent;
  font-size: var(--text-sm);
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  max-width: 100%;
  text-decoration: none;
  transition:
    background-color var(--transition-fast),
    border-color var(--transition-fast),
    color var(--transition-fast);
}

.button svg {
  flex: none;
  width: 18px;
  height: 18px;
}

.primary {
  background: var(--color-primary);
  color: #fff;
}

.primary:hover:not(:disabled) {
  background: var(--color-primary-hover);
}

.secondary {
  background: var(--color-surface);
  border-color: var(--color-control-border);
  color: var(--color-ink);
}

.secondary:hover:not(:disabled) {
  background: var(--color-surface-soft);
}

.ghost {
  background: transparent;
  color: var(--color-ink);
}

.ghost:hover:not(:disabled) {
  background: var(--color-surface-soft);
}

.danger {
  background: var(--color-danger);
  color: #fff;
}

.danger:hover:not(:disabled) {
  background: #7f1d24;
}

/* Toggle buttons (aria-pressed), such as the drawing tools' Square and From center. */
.button[aria-pressed='true'] {
  background: var(--color-primary-soft);
  border-color: var(--color-primary);
  color: var(--color-primary);
}

.small {
  min-height: 32px;
  padding: 0 var(--space-3);
  font-size: var(--text-xs);
}

.button:disabled {
  opacity: 0.55;
}

.iconButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--control-height);
  height: var(--control-height);
  border-radius: var(--radius-control);
  border: 1px solid transparent;
  background: transparent;
  color: var(--color-ink);
  transition: background-color var(--transition-fast);
}

.iconButton svg {
  width: 20px;
  height: 20px;
}

.iconButton:hover:not(:disabled) {
  background: var(--color-surface-soft);
}

.iconButton[aria-pressed='true'] {
  background: var(--color-primary-soft);
  border-color: var(--color-primary);
  color: var(--color-primary);
}

.iconButton:disabled {
  opacity: 0.4;
}

.iconButtonSmall {
  width: 32px;
  height: 32px;
}

.iconButtonSmall svg {
  width: 16px;
  height: 16px;
}

@media (pointer: coarse) {
  .button {
    min-height: var(--target-min);
  }

  .iconButton {
    width: var(--target-min);
    height: var(--target-min);
  }
}

/* On phones long labels wrap inside the button instead of pushing past the screen edge. */
@media (max-width: 640px) {
  .button {
    white-space: normal;
    text-align: center;
    line-height: 1.25;
    padding-top: 6px;
    padding-bottom: 6px;
  }
}
